import React from 'react';
import { Link } from 'react-router-dom';
import CampoComboParametro from '../../UI/campos/CampoComboParametro.js';
import CampoComboPais from '../../UI/campos/CampoComboPais.js';
import CampoComboDivision from '../../UI/campos/CampoComboDivision.js';
import CampoComboOrganizador from '../../UI/campos/CampoComboOrganizador.js';
import CampoEditableTexto from '../../UI/campos/CampoEditableTexto.js';
import CampoEditableMultilinea from '../../UI/campos/CampoEditableMultilinea.js';
import * as Campos from '../../constantes/Campos.js';
import * as TipoParametro from '../../constantes/TipoParametro.js';
import { TextoMultilinea } from '../../funciones/FuncionesTexto.js';
import styles from './CamposTorneo.module.css';

const CamposTorneoDatosBasicos = (props) => {
  const torneo = props.torneo;
  const editar = props.editar;

  const onCampoChange = (campo, valor) => {
    props.onCampoChange(campo, valor);
  };

  // Función para obtener la URL del tipo de torneo
  const obtenerURLTipoTorneo = (torneo) => {
    if (!torneo || !torneo.tipoTorneo) return null;

    const esDePais = torneo.tipoTorneo.oficialidad?.dePais;

    if (esDePais) {
      const idPais = torneo.pais?.id;
      if (!idPais) return null;

      // Si tiene división, no mostrar link (el link irá en la división)
      if (torneo.division?.id) {
        return null;
      } else {
        // Tiene país pero no división
        return `/torneosPais/${idPais}`;
      }
    } else {
      // No es de un país (internacional)
      const codTipoTorneo = torneo.tipoTorneo.codigo;
      if (!codTipoTorneo) return null;
      return `/torneosInt/${codTipoTorneo}`;
    }
  };

  // Función para obtener la URL de la división
  const obtenerURLDivision = (torneo) => {
    if (!torneo || !torneo.division) return null;

    const idPais = torneo.pais?.id;
    const idDivision = torneo.division.id;

    if (!idPais || !idDivision) return null;

    return `/torneosPais/${idPais}/division/${idDivision}`;
  };

  return (
    <table className={`${styles.tablaDatos}`}>
      {!editar && torneo && (
        <tbody>
          <tr>
            <td className={`${styles.titulo}`}>Nombre</td>
            <td className={`${styles.valor}`}>
              <CampoEditableTexto
                estilo={`${styles.campoDescripcion}`}
                editar={editar}
                nombre={Campos.Torneo.DESCRIPCION}
                valor={torneo?.descripcion || ''}
                largo={100}
                onChange={onCampoChange}
              />
            </td>
          </tr>

          <tr>
            <td className={`${styles.titulo}`}>Tipo Torneo</td>
            <td className={`${styles.valor}`}>
              {editar ? (
                <CampoComboParametro
                  estilo={`${styles.comboTipoTorneo}`}
                  editar={editar}
                  nombre={Campos.Torneo.TIPO_TORNEO}
                  tipoParametro={TipoParametro.TIPO_TORNEO}
                  valor={torneo?.tipoTorneo}
                  campoDescripcion={'nombre'}
                  onChange={onCampoChange}
                />
              ) : (
                (() => {
                  const urlTipoTorneo = obtenerURLTipoTorneo(torneo);
                  const nombreTipoTorneo = torneo?.tipoTorneo?.nombre || '';
                  return urlTipoTorneo ? (
                    <Link to={urlTipoTorneo}>{nombreTipoTorneo}</Link>
                  ) : (
                    nombreTipoTorneo
                  );
                })()
              )}
            </td>
          </tr>

          {torneo?.tipoTorneo?.oficialidad?.dePais && torneo?.pais && (
            <tr>
              <td className={`${styles.titulo}`}>País</td>
              <td className={`${styles.valor}`}>
                <CampoComboPais
                  estilo={`${styles.comboPais}`}
                  editar={editar}
                  nombre={Campos.Torneo.PAIS}
                  valor={torneo?.pais}
                  incluirNulo={false}
                  onChange={onCampoChange}
                />
              </td>
            </tr>
          )}

          {torneo?.categoria && (
            <tr>
              <td className={`${styles.titulo}`}>Categoría</td>
              <td className={`${styles.valor}`}>
                <CampoComboParametro
                  estilo={`${styles.comboCategoria}`}
                  editar={editar}
                  nombre={Campos.Torneo.CATEGORIA}
                  tipoParametro={TipoParametro.CATEGORIA}
                  valor={torneo?.categoria}
                  onChange={onCampoChange}
                />
              </td>
            </tr>
          )}

          {torneo?.organizador && (
            <tr>
              <td className={`${styles.titulo}`}>Organizador</td>
              <td className={`${styles.valor}`}>
                <CampoComboOrganizador
                  estilo={`${styles.comboOrganizador}`}
                  editar={editar}
                  nombre={Campos.Torneo.ORGANIZADOR}
                  valor={torneo?.organizador}
                  onChange={onCampoChange}
                />
              </td>
            </tr>
          )}

          {torneo?.tipoTorneo?.oficialidad?.dePais && torneo?.division && (
            <tr>
              <td className={`${styles.titulo}`}>División</td>
              <td className={`${styles.valor}`}>
                {editar ? (
                  <CampoComboDivision
                    estilo={`${styles.comboDivision}`}
                    editar={editar}
                    nombre={Campos.Torneo.DIVISION}
                    valor={torneo?.division}
                    idPais={torneo?.pais?.id}
                    onChange={onCampoChange}
                  />
                ) : (
                  (() => {
                    const urlDivision = obtenerURLDivision(torneo);
                    const nombreDivision = torneo?.division?.descripcion || '';
                    return urlDivision ? (
                      <Link to={urlDivision}>{nombreDivision}</Link>
                    ) : (
                      nombreDivision
                    );
                  })()
                )}
              </td>
            </tr>
          )}

          {torneo?.trofeo && (
            <tr>
              <td className={`${styles.titulo}`}>Trofeo</td>
              <td className={`${styles.valor}`}>
                <CampoComboParametro
                  estilo={`${styles.comboTrofeo}`}
                  editar={editar}
                  nombre={Campos.Torneo.TROFEO}
                  tipoParametro={TipoParametro.TROFEO}
                  valor={torneo?.trofeo}
                  onChange={onCampoChange}
                />
              </td>
            </tr>
          )}

          {torneo?.observaciones && (
            <tr>
              <td className={`${styles.titulo}`}>Observaciones</td>
              <td className={`${styles.valor}`}>{TextoMultilinea(torneo.observaciones)}</td>
            </tr>
          )}
        </tbody>
      )}
      {editar && (
        <tbody>
          <tr>
            <td className={`${styles.titulo}`}>Nombre</td>
            <td className={`${styles.valor}`}>
              <CampoEditableTexto
                estilo={`${styles.campoDescripcion}`}
                editar={editar}
                nombre={Campos.Torneo.DESCRIPCION}
                valor={torneo?.descripcion || ''}
                largo={100}
                onChange={onCampoChange}
              />
            </td>
          </tr>

          <tr>
            <td className={`${styles.titulo}`}>Tipo Torneo</td>
            <td className={`${styles.valor}`}>
              {editar ? (
                <CampoComboParametro
                  estilo={`${styles.comboTipoTorneo}`}
                  editar={editar}
                  nombre={Campos.Torneo.TIPO_TORNEO}
                  tipoParametro={TipoParametro.TIPO_TORNEO}
                  valor={torneo?.tipoTorneo}
                  campoDescripcion={'nombre'}
                  onChange={onCampoChange}
                />
              ) : (
                (() => {
                  const urlTipoTorneo = obtenerURLTipoTorneo(torneo);
                  const nombreTipoTorneo = torneo?.tipoTorneo?.nombre || '';
                  return urlTipoTorneo ? (
                    <Link to={urlTipoTorneo}>{nombreTipoTorneo}</Link>
                  ) : (
                    nombreTipoTorneo
                  );
                })()
              )}
            </td>
          </tr>

          {torneo?.tipoTorneo?.oficialidad?.dePais && (
            <tr>
              <td className={`${styles.titulo}`}>País</td>
              <td className={`${styles.valor}`}>
                <CampoComboPais
                  estilo={`${styles.comboPais}`}
                  editar={editar}
                  nombre={Campos.Torneo.PAIS}
                  valor={torneo?.pais}
                  incluirNulo={false}
                  onChange={onCampoChange}
                />
              </td>
            </tr>
          )}

          <tr>
            <td className={`${styles.titulo}`}>Categoría</td>
            <td className={`${styles.valor}`}>
              <CampoComboParametro
                estilo={`${styles.comboCategoria}`}
                editar={editar}
                nombre={Campos.Torneo.CATEGORIA}
                tipoParametro={TipoParametro.CATEGORIA}
                valor={torneo?.categoria}
                onChange={onCampoChange}
              />
            </td>
          </tr>

          <tr>
            <td className={`${styles.titulo}`}>Organizador</td>
            <td className={`${styles.valor}`}>
              <CampoComboOrganizador
                estilo={`${styles.comboOrganizador}`}
                editar={editar}
                nombre={Campos.Torneo.ORGANIZADOR}
                valor={torneo?.organizador}
                onChange={onCampoChange}
              />
            </td>
          </tr>

          {torneo?.tipoTorneo?.oficialidad?.dePais && (
            <tr>
              <td className={`${styles.titulo}`}>División</td>
              <td className={`${styles.valor}`}>
                {editar ? (
                  <CampoComboDivision
                    estilo={`${styles.comboDivision}`}
                    editar={editar}
                    nombre={Campos.Torneo.DIVISION}
                    valor={torneo?.division}
                    idPais={torneo?.pais?.id}
                    onChange={onCampoChange}
                  />
                ) : torneo?.division ? (
                  (() => {
                    const urlDivision = obtenerURLDivision(torneo);
                    const nombreDivision = torneo?.division?.descripcion || '';
                    return urlDivision ? (
                      <Link to={urlDivision}>{nombreDivision}</Link>
                    ) : (
                      nombreDivision
                    );
                  })()
                ) : (
                  ''
                )}
              </td>
            </tr>
          )}

          <tr>
            <td className={`${styles.titulo}`}>Trofeo</td>
            <td className={`${styles.valor}`}>
              <CampoComboParametro
                estilo={`${styles.comboTrofeo}`}
                editar={editar}
                nombre={Campos.Torneo.TROFEO}
                tipoParametro={TipoParametro.TROFEO}
                valor={torneo?.trofeo}
                onChange={onCampoChange}
              />
            </td>
          </tr>

          <tr>
            <td className={`${styles.titulo}`}>Observaciones</td>
            <td className={`${styles.valor}`}>
              <CampoEditableMultilinea
                filas="3"
                columnas="50"
                nombre={Campos.Torneo.OBSERVACIONES}
                valor={torneo?.observaciones || ''}
                editar={editar}
                onChange={onCampoChange}
              />
            </td>
          </tr>

          <tr>
            <td className={`${styles.tituloLow}`}>Dudas</td>
            <td className={`${styles.valor}`}>
              <CampoEditableMultilinea
                filas="2"
                columnas="50"
                nombre={Campos.Torneo.DUDAS}
                valor={torneo?.dudas || ''}
                editar={editar}
                onChange={onCampoChange}
              />
            </td>
          </tr>
        </tbody>
      )}
    </table>
  );
};

export default CamposTorneoDatosBasicos;
